import { render } from "./PhotoCarousel.vue?vue&type=template&id=3f29638a&scoped=true"
import script from "./PhotoCarousel.vue?vue&type=script&lang=js"
export * from "./PhotoCarousel.vue?vue&type=script&lang=js"

import "./PhotoCarousel.vue?vue&type=style&index=0&id=3f29638a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f29638a"]])

export default __exports__